'use strict';

var Hounisen = Hounisen || {};

Hounisen.slider = new function () {

    var self = this,
        prevHtml = '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/icons/icons.svg#arrow-left"></use></svg>',
        nextHtml = '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/icons/icons.svg#arrow-right"></use></svg>';

    this.categoryCarousel = function (selector) {
        selector.owlCarousel({
            lazyLoad: true,
            nav: true,
            loop: false,
            navText: [prevHtml, nextHtml],
            dots: true,
            responsive: {
                0: {
                    items: 1,
                    nav: false
                },

                479: {
                    items: 2,
                    nav: false
                },

                992: {
                    items: 4,
                    slideBy: 4
                }
            }
        });
    };

    this.universeSlider = function (selector) {
        selector.owlCarousel({
            lazyLoad: true,
            navText: [prevHtml, nextHtml],
            navContainerClass: 'custom-nav-container', // Custom navigation container class
            loop: true,
            margin: 10,
            dots: false,
            nav: true,
            responsive: {
                0: {
                    items: 1,
                    mouseDrag: true,
                    touchDrag: true
                },
                479: {
                    items: 2,

                    mouseDrag: true,
                    touchDrag: true
                },
                992: {
                    items: 4,
                    slideBy: 4,
                }
            }
        });

    };


    this.universeSliderGrey = function (selector) {
        selector.owlCarousel({
            lazyLoad: true,
            navText: [prevHtml, nextHtml],
            navContainerClass: 'custom-nav-container custom-nav-container--grey', // Custom navigation container class
            loop: true,
            margin: 10,
            dots: false,
            nav: true,
            responsive: {
                0: {
                    items: 1,
                    mouseDrag: true,
                    touchDrag: true
                },
                479: {
                    items: 2,
                    mouseDrag: true,
                    touchDrag: true
                },
                992: {
                    items: 4,
                    slideBy: 4,
                }
            }
        });

    };



};
